import React from "react";
import autoBind from "react-autobind";
import Checkbox from "@material-ui/core/Checkbox";
import FormControlLabel from "@material-ui/core/FormControlLabel";

export default class FieldCheck extends React.Component {
  constructor(props) {
    super(props);
    autoBind(this);
  }

  handleChange(event) {
    const {name, value} = this.props;
    this.props.onChange({name, value});
  }
  render() {
    const {label} = this.props;
    const _props = {...this.props};
    _props.onChange = this.handleChange;
    //_props.onCheck = this.handleChange;
    return label ? (
      <FormControlLabel label={label} control={<Checkbox color="primary" {..._props} />} />
    ) : (
      <Checkbox color="primary" {..._props} />
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/FieldCheck/index.jsx